import {Component} from '@angular/core';
import {ElementRef} from '@angular/core';
import {Input} from '@angular/core';
import {OnInit} from '@angular/core';

import {UISvgIconService} from './svg-icon.service';

@Component({
    selector: 'svg-icon',
    styleUrls: ['svg-icon.component.scss'],
    template: ''
})
export class UISvgIconComponent implements OnInit {

    @Input()
    src: string;

    @Input()
    focusable: boolean;

    constructor(private _elementRef: ElementRef, private _svgIconService: UISvgIconService) {
    }

    ngOnInit() {
        this._svgIconService.loadSvg(this.src).subscribe(svg => {
            const svgElement = <HTMLElement>svg.cloneNode(true);
            if (this.focusable !== undefined) {
                svgElement.setAttribute('focusable', this.focusable.toString());
            }
            const nativeElement = this._elementRef.nativeElement;
            nativeElement.innerHTML = '';
            nativeElement.appendChild(svgElement);
        });
    }
}